import { Form } from "@evercityecosystem/evercity-ui";
import withThreadsHoc from "../../helpers/withThreadsHoc";

export default withThreadsHoc(Form.ThreadItem, ({ label }) => label);
